pn-scroll {
  .scroll-wrapper {
    transition: all var(--transition-duration) ease-in-out 250ms;

    &.fade {
      opacity: 0;

      &.in-view {
        opacity: 1;
      }
    }

    &.slide-up {
      transform: translateY(50px);
      &.in-view {
        transform: translateY(0);
      }
    }

    &.slide-in {
      &.in-view {
      }
    }

    &.slide-out {
      &.in-view {
      }
    }
  }
}
